'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StatesControllerService;

var _defaultStateControllerTpl = require('./default-state-controller.tpl.html');

var _defaultStateControllerTpl2 = _interopRequireDefault(_defaultStateControllerTpl);

var _entityStateControllerTpl = require('./entity-state-controller.tpl.html');

var _entityStateControllerTpl2 = _interopRequireDefault(_entityStateControllerTpl);

var _defaultStateController = require('./default-state-controller');

var _defaultStateController2 = _interopRequireDefault(_defaultStateController);

var _entityStateController = require('./entity-state-controller');

var _entityStateController2 = _interopRequireDefault(_entityStateController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/


/* eslint-enable import/no-unresolved, import/default */

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

function StatesControllerService() {

    var statesControllers = {};
    statesControllers['default'] = {
        controller: _defaultStateController2.default,
        templateUrl: _defaultStateControllerTpl2.default
    };
    statesControllers['entity'] = {
        controller: _entityStateController2.default,
        templateUrl: _entityStateControllerTpl2.default
    };

    var service = {
        registerStatesController: registerStatesController,
        getStateControllers: getStateControllers,
        getStateController: getStateController,
        preserveStateControllerState: preserveStateControllerState,
        withdrawStateControllerState: withdrawStateControllerState,
        cleanupPreservedStates: cleanupPreservedStates
    };

    return service;

    function registerStatesController(id, stateControllerInfo) {
        statesControllers[id] = stateControllerInfo;
    }

    function getStateControllers() {
        return statesControllers;
    }

    function getStateController(id) {
        return statesControllers[id];
    }

    function preserveStateControllerState(id, state) {
        statesControllers[id].state = angular.copy(state);
    }

    function withdrawStateControllerState(id) {
        var state = statesControllers[id].state;
        statesControllers[id].state = null;
        return state;
    }

    function cleanupPreservedStates() {
        for (var id in statesControllers) {
            statesControllers[id].state = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/states/states-controller.service.js